import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Gwequipment from '../entities/gwequipment'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface GwequipmentState extends ListState<Gwequipment>{
    editGwequipment:Gwequipment
}
class UserMutations extends ListMutations<Gwequipment>{

}
class GwequipmentModule extends ListModule<GwequipmentState,any,Gwequipment>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Gwequipment>(),
        loading:false,
        editGwequipment:new Gwequipment()
    }
    actions={
        async getAll(context:ActionContext<GwequipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThGateway/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Gwequipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            return page.items;
        },
        async getPaged(context:ActionContext<GwequipmentState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThGateway/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Gwequipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<GwequipmentState,any>,payload:any){
            await Ajax.post('/api/services/app/ThGateway/Create',payload.data);
        },
        async uploadimg(context:ActionContext<GwequipmentState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<GwequipmentState,any>,payload:any){
            await Ajax.put('/api/services/app/ThGateway/Update',payload.data);
        },
        async delete(context:ActionContext<GwequipmentState,any>,payload:any){
            await Ajax.delete('/api/services/app/ThGateway/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<GwequipmentState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/ThGateway/GetById?Id='+payload.id);
            return reponse.data.result as Gwequipment;
        },
        ///获取设备数量
        async getCount(context:ActionContext<GwequipmentState,any>,payload:any){
            //console.log(payload);
            let reponse=await Ajax.get('/api/services/app/ThGateway/GetCount?status='+payload.data.status);
            return reponse.data.result.count;
        }
    };
    mutations={
        setCurrentPage(state:GwequipmentState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:GwequipmentState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:GwequipmentState,gwequipment:Gwequipment){
            
            state.editGwequipment=gwequipment;
            //console.log(state.editFloor);
        }
    }
}
const gwequipmentModule=new GwequipmentModule();
export default gwequipmentModule;